<div mat-dialog-title>
    ผู้ที่มีส่วนร่วมในการทำแบบทดสอบ
    <div style="float: right; margin-top: -5px;">

        <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()"
            style="float: right; margin-top: -6px;">
            <img src="../../../../assets/close-white.png" style="width: 12px;">
        </button>
    </div>
</div>

<mat-dialog-content class="mat-typography" style="padding: 0px 3%;">
    <div *ngIf="informantForm" class="container pb-4">
        <p class="header pb-2">
            กรอกอีเมลที่ต้องการเชิญให้ร่วมทำแบบทดสอบ
        </p>
        <p class="sub-header py-2">
            กรุณากรอกให้ครบทุกช่อง หากกรอกไม่ครบ คุณจะไม่สามารถเริ่มทำแบบทดสอบได้
        </p>

        <form [formGroup]="informantForm">
            <div *ngFor="let p of informantForm.get('TO')['controls']; let i = index" formArrayName="TO">
                <div class="row justify-content-center" [formGroupName]="i">
                    <div class="col-lg-8 col-md-8 col-sm-12 col-12 py-2" style="position: relative;">
                        <label [for]="informant_person[i].TAG" class="form-label">
                            {{ informant_person[i].TAG }}*
                        </label>
                        <input (blur)="checkUser(informantForm['controls'].TO['controls'][i],
                        informantForm['controls'].TO['controls'][i].value.MEASURE_CLIENT_EMAIL , i)"
                        (input)="checkArray()"
                            [ngClass]="!informantForm['controls'].TO['controls'][i].valid && informant_person[i].isError ? 'border-danger' : ''"
                            type="email" formControlName="MEASURE_CLIENT_EMAIL" class="form-control"
                            placeholder="โปรดระบุอีเมล" [id]="informant_person[i].TAG">
                        <small *ngIf="!informantForm['controls'].TO['controls'][i].valid && informant_person[i].isError"
                            class="text-danger">
                            {{ informant_person[i].errorTips }}
                        </small>
                        <img *ngIf="!informantForm['controls'].TO['controls'][i].valid && informant_person[i].isError"
                            src="assets/warn.png" class="input-icon" alt="">
                        <img *ngIf="informantForm['controls'].TO['controls'][i].valid && informant_person[i].isError === false"
                            src="assets/check (green).png" class="success-icon" alt="">
                    </div>
                </div>
            </div>
        </form>

        <div class="d-flex justify-content-center mt-3">
            <div *ngIf="canSend" (click)="submitForm(informantForm.value)" class="btn submit-btn">
                ส่งและเริ่มทำแบบทดสอบ
            </div>
            <div *ngIf="!canSend" class="btn submit-btn disabled">
                ส่งและเริ่มทำแบบทดสอบ
            </div>
        </div>
    </div>
</mat-dialog-content>